import React, { Component } from 'react';
require('es6-promise').polyfill();
require('isomorphic-fetch');
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'
import NavList from './components/navigation/NavList'
import Home from './components/pages/Home'
import PageList from './components/pages/PageList'
import util_fetch from './helpers/util_fetch.js'
import PostList from './components/posts/PostList'

class App extends Component {
  constructor(){
    super()
    this.state = {
      // data
      name: '',
      description: '',
      home: '',
      url: '',
      menu: [],
      pages: [],
      categories: [],
      posts: [],
    }
  }
  
  componentDidMount() {
    this.fetch_data();
  }

  fetch_data(){
    util_fetch.site_data('?_json=receiveData')
    .then((res) => {
      this.setState({
        name: res.name,
        description: res.description,
        home: res.home,
        url: res.url,
      })
    })
    util_fetch.site_data('menus/v1/menus/main')
    .then((res) => {
      this.setState({
        menu: res.items
      })
    })
    util_fetch.site_data('wp/v2/pages')
    .then((res) => {
      this.setState({
        pages: res
      })
    })
    util_fetch.site_data('wp/v2/categories')
    .then((res) => {
      this.setState({
        categories: res
      })
    })
    util_fetch.site_data('wp/v2/posts')
    .then((res) => {
      this.setState({
        posts: res
      })
    })
  }

  render() {

    const PageWithProps = ({ match }) => (
      <PageList 
        data_pages={this.state.pages} 
        data_posts={this.state.posts}
        data_categories={this.state.categories}
        match={match} 
      />
    )

    const PostWithProps = ({ match }) => (
      <PostList
        data_posts={this.state.posts} 
        match={match} 
      />
    )
    
    return (
      <Router>
        <div className="App">
          <div className="App-header">
            <h2>
              <Link to="/">
                {this.state.name}
              </Link>
            </h2>
          </div>
          < NavList 
            data={this.state.menu} 
          />
          {/*<Link to='news'>News</Link>*/}

          <hr />

          <Route exact path="/" component={Home}/>
          <Route path="/:id" {...this.state.pages} {...this.state.posts} component={PageWithProps}/>
          {/*<Route path="/news/" {...this.state.pages} component={PostWithProps}/>*/}

        </div>
      </Router>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js